import { cx } from "./cx";

export type IconName =
  | "activity-heart"
  | "alert-circle"
  | "alert-triangle"
  | "analytics"
  | "bell"
  | "billing"
  | "bolt"
  | "bookmark"
  | "briefcase"
  | "building"
  | "calendar"
  | "check"
  | "check-circle"
  | "browser"
  | "chevron-down"
  | "chevron-left"
  | "clipboard"
  | "clipboard-check"
  | "clock"
  | "credit-card"
  | "database"
  | "domains"
  | "dots"
  | "edit"
  | "eye"
  | "eye-off"
  | "file"
  | "filter"
  | "flag"
  | "globe"
  | "graduation-hat"
  | "grid"
  | "home"
  | "info-circle"
  | "link"
  | "link-external"
  | "lock"
  | "mail"
  | "manage-chevron"
  | "notifications"
  | "refresh"
  | "refresh-ccw"
  | "scales"
  | "search"
  | "server"
  | "settings"
  | "share"
  | "shield-tick"
  | "switcher-chevron"
  | "tag"
  | "target"
  | "trend-up"
  | "upload-cloud"
  | "user"
  | "users"
  | "website"
  | "zap";

/** Glyphs that sit inset in their Figma frame instead of filling it: [width, height]. */
const GLYPH: Partial<Record<IconName, [number, number]>> = {
  domains: [16.5, 13.5],
  notifications: [13.5, 12.375],
};

/**
 * A Figma icon (public/icons) painted in `currentColor` through a CSS mask, so one asset serves
 * every state (active nav item, hover, muted text).
 */
export function Icon({ name, size = 18, className }: { name: IconName; size?: number; className?: string }) {
  const [w, h] = GLYPH[name] ?? [size, size];
  const url = `url(/icons/${name}.svg)`;
  return (
    <span
      aria-hidden
      className={cx("inline-flex shrink-0 items-center justify-center", className)}
      style={{ width: size, height: size }}
    >
      <span
        className="block bg-current"
        style={{
          width: w,
          height: h,
          maskImage: url,
          WebkitMaskImage: url,
          maskSize: "100% 100%",
          WebkitMaskSize: "100% 100%",
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
        }}
      />
    </span>
  );
}
